<template>
  <NxInput
    name="numId"
    type="text"
    label="NumID:"
    placeholder="Digite o NumID"
    :value="localValue"
    @update:value="handleValueUpdate"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputNumId',
  mixins: [useReactiveModelMixin('value')],

  data () {
    return {
      disabled: false
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputNumId.vue